import type { WithChildNodes } from "./types.ts";

type Options<TNode extends WithChildNodes<TNode>> = {
  filter?: (node: TNode) => boolean;
};

export const flattenNodes = <TNode extends WithChildNodes<TNode>>(startNode: TNode, options?: Options<TNode>) => {
  const nodes: TNode[] = [];
  const recurseFlattenNodes = (node?: TNode) => {
    if (!node || (options?.filter && !options.filter(node))) {
      return;
    }

    nodes.push(node);

    for (const value of Object.values(node.childNodes)) {
      if (Array.isArray(value)) {
        for (const child of value) {
          recurseFlattenNodes(child);
        }
      } else {
        recurseFlattenNodes(value);
      }
    }
  };

  recurseFlattenNodes(startNode);

  return nodes;
};
